import { gql } from '@apollo/client';

export const GET_INSTITUTIONS_BY_EXACT_FIELD_MATCH = gql`
  query GetInstitutionsByExactFieldMatch($input: InstitutionByExactFieldMatchInput!) {
    institutions: getInstitutionsByExactFieldMatch(input: $input) {
      id
      name
      trackingCode
      ecdRegistrations {
        id
        submitted
      }
    }
  }
`;
